module.exports = "/virtual-football-league/img/amblems/right/logos/Bayern.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/Bayern.png
// module id = 2160
// module chunks = 4